import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, type Stripe } from '@stripe/stripe-js'
import { type ReactNode, useEffect, useState } from 'react'
import { STRIPE_CONFIG, isStripeConfigured } from '../../config/stripe'

let stripePromise: Promise<Stripe | null> | null = null

/**
 * Initialize Stripe only once
 */
const getStripe = () => {
  if (!stripePromise && isStripeConfigured()) {
    stripePromise = loadStripe(STRIPE_CONFIG.publishableKey)
  }
  return stripePromise
}

interface StripeProviderProps {
  children: ReactNode
}

/**
 * Stripe Elements Provider wrapper
 * Provides Stripe context to child components
 */
export function StripeProvider({ children }: StripeProviderProps) {
  const [stripe, setStripe] = useState<Promise<Stripe | null> | null>(null)

  useEffect(() => {
    if (isStripeConfigured()) {
      setStripe(getStripe())
    } else {
      console.warn('Stripe publishable key not configured. Set VITE_STRIPE_PUBLISHABLE_KEY in .env')
    }
  }, [])

  if (!isStripeConfigured()) {
    return <>{children}</>
  }

  if (!stripe) {
    return <div>Loading payment provider...</div>
  }

  return (
    <Elements
      stripe={stripe}
      options={{
        mode: 'setup',
        currency: 'usd',
        appearance: {
          theme: 'stripe',
          variables: {
            colorPrimary: '#0B4D2A',
            fontFamily: 'system-ui, sans-serif',
            borderRadius: '8px',
          },
        },
      }}
    >
      {children}
    </Elements>
  )
}
